<template>
  <div>
    <div class="header">
      <img
        src="@/assets/image/message/tou.png"
        alt="头像"
      >
      <div class="mess">
        <div>
          <label>准考证号：</label>
          <p>{{user.exam_no || '111111111111111'}}</p>
        </div>
        <div>
          <label>姓名：</label>
          <p>{{user.user_name || 'XXX'}}</p>
        </div>
        <div>
          <label>性别：</label>
          <p>x</p>
        </div>
        <div>
          <label>证件类型：</label>
          <p>居民身份证</p>
        </div>
        <div>
          <label>证件号码：</label>
          <p>{{this.$store.state.user.user_id_no || '111111111111111111'}}</p>
        </div>
      </div>
      <span class="jwh"><label>机位号:</label>111</span>
    </div>
    <div class="main">
      <div class="perMes">
        <!-- <p class="one">{{time}}秒后进入下一科目考试</p> -->
        <a
          href="javascript:;"
          @click="nextSubject"
          class="nextIn"
          v-if="is_give_up"
        >继续考试</a>
        <a
          href="javascript:;"
          class="giveUp"
          @click="warn_dialog = true"
          v-if="is_give_up"
        >放弃考试</a>
      </div>
    </div>
    <div
      class="window"
      :class="{'again':again_sure}"
      v-if="warn_dialog"
    >
      <div class="hs"></div>
      <div class="windowContent">
        <p class="sure">请确认是否放弃下一科目考试？</p>
        <div class="btn">
          <a
            href="javascript:;"
            class="yes"
            @click="yes"
          >是</a>
          <a
            href="javascript:;"
            class="no"
          >否</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      warn_dialog: false,
      again_sure: false,
      time: 2//倒计时时间
    }
  },
  created () {
    this.countdown();
    this.$store.commit("answer", {});
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    is_login_again () {
      return this.$store.state.config.is_login_again;
    },
    is_give_up () {
      return this.$store.state.config.is_give_up;
    }
  },
  methods: {
    //跳转到下一科目
    nextSubject () {
      let cur_time = new Date().getTime();
      let cur_subject = this.$store.state.exam.cur_subject;
      let end_time = cur_time + cur_subject.duration * 60 * 1000;

      let exam = this.$store.state.exam;
      exam.exam_end_time = end_time;
      this.$store.commit("exam", exam);
      if (this.is_login_again == "1") {
        this.$router.push({
          name: "Login"
          , params: { project_code: this.$store.state.project.project_code, subject_code: cur_subject.subject_code }
        });
      } else {
        this.$router.push({
          name: "Exam2"
          , params: { project_code: this.$store.state.project.project_code }
        });
      }





    },
    //弹出框点击是
    yes () {
      if (!this.again_sure) {
        this.again_sure = true;
      } else {
        this.$router.push({ name: "Success", params: { project_code: this.$route.params.project_code } });
      }
    },

    //倒计时，时间到了自动跳到下一个科目
    countdown () {
      this.time = this.time - 1;
      let this_ = this;
      if (this.time > 0) {
        setTimeout(function () {
          this_.countdown();
        }, 1000);
      } else {
        this.nextSubject();

      }
    },
  },
}
</script>
<style lang='scss' scoped src="../assets/css/next.scss">
</style>